import styled from 'styled-components';

export const Background = styled.div`
    position: relative;
    width: 98%;
    max-width: 90%;
    margin: 30vh auto 60px;
    padding: 80px 20px 60px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
`;

export const Header = styled.div`
    h2 {
        font-size: 40px;
        font-weight: normal;
    }
    
    .title {
        height: 70px;
        border-right: 3px solid #f0f;
    }
    span {
        font-size: 16px;
    }       
    
    #partner-info-wallet {
        margin-left: 40px;
        margin-right: 80px;
    } 
`;

// SUMMARY Component Style

export const SummaryBox = styled.div`
    position: relative;
    width: auto;
    height: 110px;
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 0px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    
    h3 {
        margin: 0px auto 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-bottom: 5px solid #263f7a;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
    }
    
    p {
        font-size: 20px;
    }
    
    #balance {
        color: #f0f;
        font-size: 20px;
        font-weight: bold;        
        padding-left: 20px;
    }
      
`;

// Amount Reedem box Style

export const AmountOperationBox = styled.div`
    position: relative;
    width: 100%;
    margin-top: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
`;